export default {
  title: {
    add: 'thêm',
    editor: 'sửa'
  },
  label: {
    createAcct: 'người tạo',
    createTime: 'thời gian tạo',
    id: 'mã chính id',
    ipList: 'địa chỉ IP',
    merchantNo: 'Tài khoản merchant',
    updateAcct: 'người cập nhật',
    updateTime: 'thời gian cập nhật',
    action: 'thao tác',
    operator: 'Nhà điều hành'
  },
  rules: {
    ipList: {
      required: 'vui lòng nhập địa chỉ IP',
      isip: 'địa chỉ Ip định dạng không đúng'
    },
    merchantNo: {
      required: 'vui lòng nhập tài khoản merchant'
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/merchantip.js